import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)<{ $hidden?: boolean; $overflow?: boolean }>`
  position: relative;
  width: fit-content;
  height: fit-content;
  overflow: ${({ $overflow = false }: { $overflow: boolean }) =>
    $overflow ? 'visible' : 'hidden'};
  display: ${({ $hidden }: { $hidden: boolean }) =>
    $hidden ? 'none' : 'block'};
`;

export const ContentWrapper = styled(Box)(
  () => `
  box-sizing: content-box;
  & * {
    box-sizing: unset;
  }
`,
);
